import { render } from "./PositionFlipCard.vue?vue&type=template&id=1a89d2ff&scoped=true"
import script from "./PositionFlipCard.vue?vue&type=script&lang=js"
export * from "./PositionFlipCard.vue?vue&type=script&lang=js"

import "./PositionFlipCard.vue?vue&type=style&index=0&id=1a89d2ff&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a89d2ff"]])

export default __exports__